import { Avatar, Overline, UIHeading3, UIText3, DocumentsZhk16 } from '@cian/ui-kit';
import * as React from 'react';

import { THomeownerProof } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import * as style from './style.css';
import { HOMEOWNER_PROOF_TEXTS } from '../../../constants/homeownerProofTexts';

export interface IHomeownerLayoutProps {
  avatar: string;
  userName: string;
  homeownerProofs: THomeownerProof[] | null;
}

export const HomeownerLayout: React.FC<IHomeownerLayoutProps> = ({ avatar, userName, homeownerProofs }) => {
  return (
    <div className={style['wrapper']}>
      <Avatar size={72} src={avatar} type="user" />

      <div className={style['title']}>
        <Overline color="gray60_100">Собственник</Overline>
        <UIHeading3 color="black_100">{userName}</UIHeading3>

        <ul className={style['proofs']}>
          {homeownerProofs?.map(proof => (
            <li key={proof}>
              <DocumentsZhk16 color="primary_100" />
              <UIText3>{HOMEOWNER_PROOF_TEXTS[proof]}</UIText3>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
